const STORAGE_KEY = "bg-removal-usage";
const COOKIE_NAME = "snky_cnt";
const FREE_DAILY_LIMIT = 5;

interface UsageData {
	date: string; // YYYY-MM-DD
	count: number;
}

function getTodayStr(): string {
	return new Date().toISOString().slice(0, 10);
}

function getCookieCount(date: string): number | null {
	try {
		const cookies = document.cookie.split(";");
		for (const c of cookies) {
			const eqIdx = c.indexOf("=");
			if (eqIdx === -1) continue;
			const name = c.slice(0, eqIdx).trim();
			const value = c.slice(eqIdx + 1).trim();
			if (name === COOKIE_NAME && value) {
				const pipeIdx = value.lastIndexOf("|");
				if (pipeIdx === -1) continue;
				const cookieDate = value.slice(pipeIdx + 1);
				const count = parseInt(value.slice(0, pipeIdx), 10);
				if (cookieDate === date && !Number.isNaN(count)) return count;
			}
		}
	} catch {
		// document が存在しない環境（SSR等）は無視
	}
	return null;
}

function setCookieCount(count: number, date: string): void {
	try {
		document.cookie = `${COOKIE_NAME}=${count}|${date}; path=/; SameSite=Lax; max-age=86400`;
	} catch {
		// SSR や cookie 無効環境は無視
	}
}

export function getUsageToday(): number {
	const today = getTodayStr();
	try {
		const raw = localStorage.getItem(STORAGE_KEY);
		if (raw) {
			const data: UsageData = JSON.parse(raw);
			if (data.date === today) return data.count;
		}
	} catch {
		// localStorage 不可 — Cookie にフォールバック
	}
	// Cookie からフォールバック
	const cookieCount = getCookieCount(today);
	return cookieCount !== null ? cookieCount : 0;
}

export function incrementUsage(): void {
	const today = getTodayStr();
	const current = getUsageToday();
	const newCount = current + 1;
	try {
		localStorage.setItem(
			STORAGE_KEY,
			JSON.stringify({ date: today, count: newCount }),
		);
	} catch {
		// Private browsing mode — silently ignore
	}
	// Cookie にも二重保存（localStorage が使えない環境のフォールバック）
	setCookieCount(newCount, today);
}

export function hasReachedFreeLimit(): boolean {
	return getUsageToday() >= FREE_DAILY_LIMIT;
}

export function getRemainingFree(): number {
	return Math.max(0, FREE_DAILY_LIMIT - getUsageToday());
}

export const FREE_DAILY_LIMIT_CONST = FREE_DAILY_LIMIT;
